module.exports = __webpack_public_path__ + "static/media/graduate.f0054fe6.jpg";